import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  APPROVAL_TABLE_HEAD_BG,
  approvalFormTableStyles,
} from '@/components/Approval/@components/ApprovalFormTable/styles';

/** V2 본문·레거시 문서 본문(Bootstrap 클래스) 모두 태그·클래스로 스타일링 */
export const StorageMaterialOrderRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& section + div, & section + section, & > div + div': { marginTop: 8 },
  '& table': { ...approvalFormTableStyles(theme), minWidth: 800 },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  // 레거시 문서는 현황·열 제목 줄이 td 라 발주 상세 제목 아래 두 줄을 머리글 색으로
  '& tr:has(> th.bg-info) + tr > td, & tr:has(> th.bg-info) + tr + tr > td': {
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
  },
  '& th.bg-info, & .textBold': { fontWeight: 600 },
  '& .bg-danger': {
    backgroundColor: 'var(--dk-danger-soft, #fef1f2)',
    fontWeight: 600,
  },
}));
